import { Grid, TextField } from '@mui/material'
import { FunctionComponent } from 'react'
import { Controller, UseFormReturn } from 'react-hook-form'

import { InputCodigoMask } from '../../../base/components/MyInputs/InputCodigoMask'
import { TipoArticuloInputProps } from '../interfaces'
import TipoArticuloNotas from './component/TipoArticuloNotas'

interface OwnProps {
  form: UseFormReturn<TipoArticuloInputProps>
  handleEdit: boolean
}

type Props = OwnProps

/**
 * Formulario de tipos de articul
 * @param props
 * @constructor
 */
const TipoArticuloForm: FunctionComponent<Props> = (props) => {
  const {
    form: {
      control,
      formState: { errors },
    },
    handleEdit,
  } = props

  return (
    <>
      <form>
        <Grid container columnSpacing={2} rowSpacing={3}>
          <Grid size={{ xs: 10, md: 4, lg: 4 }}>
            <Controller
              name="codigo"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Código"
                  size="small"
                  fullWidth
                  disabled={handleEdit}
                  slotProps={{
                    input: {
                      inputComponent: InputCodigoMask as any,
                    },
                  }}
                  error={!!errors.codigo}
                  helperText={errors.codigo && errors.codigo.message?.toString()}
                />
              )}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 8, lg: 8 }}>
            <Controller
              name="descripcion"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Descripción"
                  size="small"
                  fullWidth
                  error={!!errors.descripcion}
                  helperText={
                    errors.descripcion && errors.descripcion.message?.toString()
                  }
                />
              )}
            />
          </Grid>
          <Grid size={12}>
            <Controller
              name="notas"
              control={control}
              render={({ field }) => (
                <TipoArticuloNotas
                  notas={field.value}
                  onChange={(value) => {
                    if (value) {
                      field.onChange(value)
                    }
                  }}
                />
              )}
            />
          </Grid>
        </Grid>
      </form>
    </>
  )
}

export default TipoArticuloForm
